import { onMounted, onUnmounted, type Ref } from 'vue'

/**
 * Registers a document-level keydown listener that calls `onClose` when Escape
 * is pressed while `isOpen` is true. Cleans up automatically on unmount.
 */
export function useEscapeToClose(isOpen: Ref<boolean>, onClose: () => void) {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape' && isOpen.value) {
      onClose()
    }
  }

  onMounted(() => document.addEventListener('keydown', handleKeyDown))
  onUnmounted(() => document.removeEventListener('keydown', handleKeyDown))
}
